import React from "react";
import Body from "../Body";
import NewsAndEvents from "../News";
import Life from "../Life";
import Campus from "../Campus";
import Classroom from "../Classroom";
import Meet from "../Meet";

const Home = () => {
  return (
    <>
      <Body />
      <NewsAndEvents />
      <Life />
      <Campus />
      <Classroom />
      <Meet />
    </>
  );
};

export default Home;
